<hlm-alert-dialog>
  <hlm-alert-dialog-content *brnAlertDialogContent class="p-6">
    <div class="flex flex-col gap-4">
      <div class="flex justify-center w-full">
        <ng-icon
          hlm
          name="lucideTrash2"
          size="xl"
          class="text-destructive"
        />
      </div>

      <div class="flex flex-col gap-2 text-center">
        <h3 class="text-lg font-semibold">
          Rimuovere il modello {{ templateTypeLabel() }}?
        </h3>
        <p class="text-sm text-muted-foreground">
          Il modello personalizzato verrà rimosso. I documenti esportati
          torneranno a usare il formato predefinito.
        </p>
      </div>

      <div class="flex flex-col gap-2">
        <button
          hlmAlertDialogAction
          variant="destructive"
          (click)="onConfirm()"
        >
          Elimina
        </button>
        <button hlmAlertDialogCancel (click)="onCancel()">Annulla</button>
      </div>
    </div>
  </hlm-alert-dialog-content>
</hlm-alert-dialog>
